var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4213_6272",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4213_6272)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.16927 13.3333V6.54159L7.0026 8.70825L5.83594 7.49992L10.0026 3.33325L14.1693 7.49992L13.0026 8.70825L10.8359 6.54159V13.3333H9.16927ZM5.0026 16.6666C4.54427 16.6666 4.15191 16.5034 3.82552 16.177C3.49913 15.8506 3.33594 15.4583 3.33594 14.9999V12.4999H5.0026V14.9999H15.0026V12.4999H16.6693V14.9999C16.6693 15.4583 16.5061 15.8506 16.1797 16.177C15.8533 16.5034 15.4609 16.6666 15.0026 16.6666H5.0026Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.5e32cfdc08bc9aba0de27496d47eb387.svg";
export { ForwardRef as ReactComponent };